import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render Young Business Leader tab data in SBA how to nominate page
 */
const YoungBusinessLeader = (): React.ReactElement => {
  return (
    <div className="bg-gray-150" data-testid="young-business-leader-component">
      <AccordionV2
        testId="young-business-leader-of-the-year"
        className="border-none py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Young Business Leader of the Year" />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 px-6 py-4">
          <ul className="list-outside list-disc pb-6 pl-8">
            <li>
              This Award is open to any individual below the age of 45 as of 1st
              January during the year of judging.
            </li>
            <li>There is no restriction on sex or race.</li>
            <li>The candidate must be ordinarily resident in Singapore.</li>
            <li>
              He/She must be involved in a business enterprise either running
              his/her own local company or head of the Singapore or foreign
              division/subsidiary of a large organisation.
            </li>
          </ul>

          <p>
            <strong>Leadership and Managerial Skills</strong>
          </p>

          <p>He/she must have these critical attributes:</p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>Entrepreneurship, and drive</li>
            <li>
              Ability to adapt to the changing business environment and
              standards
            </li>
            <li>
              Ability to steer his/her organisation towards problem solving and
              out performance
            </li>
            <li>
              Contribute to the upgrading of managerial skills and the
              establishment of a viable organisation structure and culture
            </li>
            <li>Persevere in working towards objectives</li>
            <li>
              Innovate and be outward looking in his/her approach to business
            </li>
            <li>Gain the respect of subordinates and peers</li>
            <li>
              Set an example for the organisation and motivate its employees
            </li>
          </ul>

          <p>
            <strong>Financial Performance</strong>
          </p>

          <p>He/she must have:</p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>
              Made an outstanding and sustained contribution to the financial
              viability of the company
            </li>
            <li>
              Contributed to an improvement on return on capital invested in the
              company
            </li>
            <li>
              Exercise prudent management of funds and/or financial assets
            </li>
          </ul>

          <p>
            <strong>Contribution to the Community</strong>
          </p>

          <p>
            He/she must have made positive contribution to Singapore and the
            international community.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default YoungBusinessLeader;
